import app from 'flarum/common/app';
import Model from 'flarum/common/Model';
app.initializers.add('glowingblue-translate-common', () => {
  app.beforeMount(() => {
    for (const type of app.forum.attribute('translatableModels')) {
      const model = app.store.models[type];
      if (!model) continue;
      model.prototype.isTranslated = Model.attribute('isTranslated');
      model.prototype.sourceLanguage = Model.attribute('sourceLanguage');
    }
  });
});